<template>
  <b-row class="h-100 my-5">
    <b-col xxs="12" md="6" class="mx-auto my-auto text-center">

      <img src="@/assets/img/logo.png" height="80" class="mb-3" />

      <div class="form-side">
        <form-base
          :btnBlock="true"
          title=""
          action="Reset"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:header>
            <h3>Reset Password</h3>
            <small>Please enter you new desired password</small>
          </template>

          <template v-slot:fields>
            <label class="form-group has-float-label mb-4">
              <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid': $v.email.$error }"
                ref="email"
                v-model="email"
              />
              <span>Email</span>
              <div class="invalid-feedback" v-if="!$v.email.required">
                Please enter email address
              </div>
              <div class="invalid-feedback" v-if="!$v.email.email">
                invalid email address
              </div>
            </label>

            <label class="form-group has-float-label mb-4">
              <input
                type="password"
                class="form-control"
                :class="{ 'is-invalid': $v.password.$error }"
                v-model="password"
              />
              <span>Password</span>
              <div class="invalid-feedback" v-if="!$v.email.required">
                Please enter password
              </div>
            </label>

          </template>

        </form-base>
      </div>

      <div class="mt-4">
        <router-link :to="{name:'forgot-password'}" class="text-primary">
          New reset email
        </router-link>
      </div>

      <b-modal ref="error-modal" title="Error">
        Invalid Token, please request new password reset email
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import authRepo from '@/api/repos/authRepo'

export default {
  components: {
    formBase
  },
  mounted () {
    this.verifyToken()
  },
  data () {
    return {
      email: this.$route.query.email,
      password: '',
      loading: false,
      errors: null
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    }
  },

  methods: {

    async verifyToken () {
      if (this.$route.query.token == null) {
        this.$refs['error-modal'].show()
      }

      try {
        await authRepo.validateToken(this.$route.query.email, this.$route.query.token)
      } catch (error) {
        console.log(error)
        if (error.response.status === 422) {
           this.$root.$bvToast.toast("Invalid Token", {
              title: "Token invalid - Re send email link",
              autoHideDelay: 3000,
              variant: "danger",
            });
          this.email = this.password = ''
        } else {
          this.$refs['error-modal'].show()
        }
      } finally {
        this.loading = false
      }
    },

    async handleSubmit () {
      this.loading = true

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.loading = false
      } else {
        try {
          await authRepo.resetPassword({
            email: this.email,
            password: this.password,
            token: this.$route.query.token
          })

          if (this.$route.params.nextUrl != null) {
            this.$router.push(this.$route.params.nextUrl)
          } else {
            this.$router.push({ name: 'home' })
          }
        } catch (error) {
          console.log(error)
          if (error.response.status === 422) {
            this.errors = []
            this.errors[0] = error.response.data.errors;
            
          } else {
            this.$refs['error-modal'].show()
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
